import React, { useState, useEffect } from "react";
import SearchIcon from "@material-ui/icons/Search";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { Tooltip } from '@material-ui/core';
import BiztranControls from "../biztran_controls/BiztranControls";
// import ModalFrame from "../../biztran_controls/Modal_Frame";
// import UseFetchData from "../../../hooks/UseFetchData";
import UseFetchData from "../../hooks/UseFetchData";
// import { Modal_Frame } as ModalFrame from "../biztran_controls/Modal_Frame"

const BranchMaster = () => {
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [Name, setName] = useState('Branch Master');
    const [TypeName, setTypeName] = useState('');
    const [MaxWidth, setMaxWidth] = useState('xs');
    const [PKID, setPKID] = useState('');
    const [Count, setCount] = useState();
    const [isOpen, setOpen] = useState(false);
    const [response, fetchData] = UseFetchData();
    // return <div>work in progress...</div>;


    const PopulateData = () => {
        var bodyFormData = new FormData();
        fetchData("Primary/BranchMaster", bodyFormData);
    }

    useEffect(() => {
        PopulateData()
    }, []
    );

    useEffect(() => {

        const gridCols = [
            {
                field: "id",
                headerName: ".",
                //renderCell: (params) => (<strong> <Link to={{ pathname: "/lead/LeadView", state: { LeadID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
                renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { }} >Edit</a> </strong>),
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 70,
            },
            {
                field: "BranchType",
                headerName: "Branch Type",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 150,
            },
            {
                field: "BranchCode",
                headerName: "Branch Code",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "BranchName",
                headerName: "Branch Name",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "State",
                headerName: "State",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "Address1",
                headerName: "Address1",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "Address2",
                headerName: "Address2",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "Address3",
                headerName: "Address3",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "Ph1",
                headerName: "Ph1",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "Ph2",
                headerName: "Ph2",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "Ph3",
                headerName: "Ph3",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "Ph4",
                headerName: "Ph4",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "FaxNo",
                headerName: "Fax No",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "Email",
                headerName: "Email",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "CanGoodsReceive",
                headerName: "CanGoodsReceive",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },

        ];
        setColumns(gridCols);
        if (response !== undefined && response.length > 0) {
            setRows(response);
            setCount(response.length);
        }
    }, [response]
    );

    return (
        <div>
            <table style={{ width: "100%" }}>
                <tbody>
                    <tr>
                        <td>
                            <table style={{ width: "100%" }}>
                                <tbody>
                                    <tr>
                                        <td>
                                            <h1>{Name}</h1>
                                        </td>
                                    </tr>

                                    <tr>
                                        <BiztranControls.Input
                                            label={"Branch Type"}
                                            id={Name}
                                            onChange={(e) => setTypeName(e.target.value)}
                                        />
                                        <BiztranControls.Button
                                            text="SEARCH"
                                            startIcon={<SearchIcon />}
                                            onClick={() => {
                                                // PopulateData();
                                            }}
                                        />
                                        <label style={{ fontWeight: 'bold', width: 10 }}>{Count}</label>
                                        <BiztranControls.Button
                                            text="ADD NEW"
                                            startIcon={<AddCircleOutlineIcon />}
                                            onClick={() => {
                                                // handleOpenModal();
                                            }}
                                        />
                                        <label style={{ fontWeight: 'bold', width: 10 }}></label>
                                        <BiztranControls.Button
                                            text="EXPORT TO EXCEL"
                                            startIcon={<AddCircleOutlineIcon />}
                                            style={{ width: "18%" }}
                                        // onClick={() => {
                                        //   handleOpenModal();
                                        // }}
                                        />
                                        {/* <ModalFrame
                                            title={Name}
                                            maxWidth={MaxWidth}
                                            isOpen={isOpen}
                                            setOpen={setOpen}
                                        > */}
                                        {/* {returnModal()} */}
                                        {/* </ModalFrame> */}
                                    </tr>
                                    <tr>
                                        <td>
                                            <BiztranControls.DataGrid
                                                rowHeight={25}
                                                headerHeight={34}
                                                // header
                                                rows={rows}
                                                columns={columns}
                                                checkboxSelection={false}
                                                hideFooterPagination={true}
                                                hideFooter={true}
                                                Height="700px"
                                                Width="100%"
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default BranchMaster;